export default __webpack_public_path__ + "static/media/bondly-wbnb-closed-stub.8dee5662.svg";